// Translations for Public Application Form
// English and Yoruba

export const translations = {
  en: {
    // Header
    appName: "WilyRash Homes",
    formTitle: "Tenant Application Form",
    timeRemaining: "remaining",
    
    // Steps
    steps: {
      personalInfo: "Personal Info",
      residency: "Residency",
      employment: "Employment",
      guarantors: "Guarantors"
    },
    
    // Step descriptions
    stepDescriptions: {
      1: "Enter your personal information and contact details",
      2: "Provide your residency history (optional but helpful)",
      3: "Tell us about your occupation",
      4: "Provide two guarantors who can vouch for you"
    },
    
    // Labels - Personal Info
    phoneNumber: "Phone Number",
    email: "Email (optional)",
    fullName: "Full Name (Surname First)",
    fullNamePlaceholder: "e.g., Smith John Michael",
    age: "Age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    // Contact Info
    contactInfo: "Contact Info",
    atLeastOneRequired: "at least one required",
    mobilePhone: "Mobile Phone #",
    whatsappPhone: "WhatsApp #",
    preferred: "preferred",
    whatsappPreferred: "WhatsApp is preferred for faster communication",
    contactRequired: "Please provide at least one contact number (Mobile or WhatsApp)",
    maritalStatus: "Marital Status",
    pleaseSpecify: "Please specify",
    nationalId: "National ID Number",
    enterNIN: "Enter NIN",
    driverLicense: "Driver's License (optional)",
    enterLicenseNumber: "Enter license number",
    
    // Marital Status Options
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    other: "Other",
    
    // Labels - Residency
    lastAddress1: "Last Address 1",
    enterPreviousAddress: "Enter your previous address",
    lastAddress2: "Last Address 2",
    anotherPreviousAddress: "Enter another previous address (if applicable)",
    lastTenantAddress: "Last Tenant Address",
    tenantAddressPlaceholder: "Address where you were a tenant",
    durationAtLastLocation: "Duration at Last Location",
    durationPlaceholder: "e.g., 2 years",
    pastLandlordPhone: "Past Landlord's Phone",
    reasonForLeaving: "Reason for Leaving",
    whyDidYouLeave: "Why did you leave your last residence?",
    canLandlordBeContacted: "Can your past landlord be contacted?",
    yes: "Yes",
    no: "No",
    
    // Labels - Employment
    occupation: "Occupation",
    selectOccupation: "Select occupation",
    employed: "Employed",
    selfEmployed: "Self-Employed",
    student: "Student",
    retired: "Retired",
    unemployed: "Unemployed",
    durationOfEmployment: "Duration of Employment",
    monthlySalary: "Monthly Salary (₦)",
    enterMonthlySalary: "Enter monthly salary",
    estimatedMonthlyReturns: "Estimated Monthly Returns (₦)",
    enterEstimatedReturns: "Enter estimated returns",
    additionalOccupants: "Additional Occupants",
    livingAlone: "None - Living alone",
    onePerson: "1 additional person",
    twoPeople: "2 additional people",
    threePeople: "3 additional people",
    fourOrMore: "4 or more people",
    rentalDuration: "How long do you plan to rent?",
    selectDuration: "Select duration",
    sixMonths: "6 months",
    oneYear: "1 year",
    twoYears: "2 years",
    threeOrMoreYears: "3+ years",
    undecided: "Undecided",
    
    // Labels - Guarantors
    guarantor1: "Guarantor 1",
    guarantor2: "Guarantor 2",
    guarantorName: "Full Name",
    enterGuarantorName: "Enter guarantor's name",
    guarantorPhone: "Phone Number",
    enterPhoneNumber: "Enter phone number",
    guarantorAddress: "Address",
    enterGuarantorAddress: "Enter guarantor's address",
    canGuarantorBeContacted: "Can this guarantor be contacted?",
    select: "Select",
    
    // Buttons
    previous: "Previous",
    next: "Next",
    submitApplication: "Submit Application",
    submitting: "Submitting...",
    requestNewLink: "Request New Link",
    goToLogin: "Go to Login",
    
    // Messages
    linkInvalidOrExpired: "Link Invalid or Expired",
    contactAdmin: "Please contact the administrator at WilyRash Homes for a new application link.",
    applicationSubmitted: "Application Submitted!",
    thankYouMessage: "Thank you for submitting your application. We will review it and contact you shortly.",
    ifApproved: "If your application is approved, you will receive an invitation to create your account.",
    completeAllFields: "Please complete all required fields",
    linkValidMessage: "Link is valid. Please complete your application before it expires.",
    applicationSubmittedSuccess: "Application submitted successfully!",
    failedToSubmit: "Failed to submit application",
    validatingLink: "Validating link...",
    
    // Footer
    footer: "WilyRash Homes Tenant Management System",
    
    // Required indicator
    required: "*",
    
    // Photo upload
    passportPhoto: "Passport Photo / Selfie",
    uploadPhoto: "Upload Photo",
    changePhoto: "Change Photo",
    photoRequired: "Photo is required",
    photoInstructions: "Please upload a clear photo of yourself",
    clickToUpload: "Click to upload",
    dragAndDrop: "or drag and drop",
    supportedFormats: "PNG, JPG, JPEG up to 5MB"
  },
  
  yo: {
    // Header
    appName: "WilyRash Homes",
    formTitle: "Fọọmu Ohun-ini fun Ayàgbé",
    timeRemaining: "kù",
    
    // Steps
    steps: {
      personalInfo: "Àlàyé Ara Ẹni",
      residency: "Itan Ibùgbé",
      employment: "Iṣẹ́",
      guarantors: "Àwọn Onígbọ̀wọ́"
    },
    
    // Step descriptions
    stepDescriptions: {
      1: "Fi àlàyé ara ẹni àti bí a ṣe lè kàn sí ẹ sílẹ̀",
      2: "Fi itan ibùgbé rẹ sílẹ̀ (kò pọn dandan ṣùgbọ́n ó ṣe ìrànwọ́)",
      3: "Sọ̀ fún wa nípa iṣẹ́ rẹ",
      4: "Fi àwọn onígbọ̀wọ́ méjì tí wọ́n lè jẹ́rìí fún ẹ sílẹ̀"
    },
    
    // Labels - Personal Info
    phoneNumber: "Nọ́mbà Fóònù",
    email: "Ímeèlì (kò pọn dandan)",
    fullName: "Orúkọ Kíkún (Orúkọ Ìdílé Kọ́kọ́)",
    fullNamePlaceholder: "f.a., Adéyẹmí Adébáyọ̀ Olúwafẹ́mi",
    age: "Ọjọ́ Orí",
    gender: "Ìbálòpọ̀",
    male: "Ọkùnrin",
    female: "Obìnrin",
    // Contact Info
    contactInfo: "Àlàyé Ìbánisọ̀rọ̀",
    atLeastOneRequired: "ó kéré kan pọn dandan",
    mobilePhone: "Nọ́mbà Fóònù Alágbèéká",
    whatsappPhone: "Nọ́mbà WhatsApp",
    preferred: "a fẹ́ràn jùlọ",
    whatsappPreferred: "WhatsApp ni a fẹ́ràn jùlọ fún ìbánisọ̀rọ̀ kíákíá",
    contactRequired: "Jọ̀wọ́ fi ó kéré nọ́mbà kan sílẹ̀ (Fóònù Alágbèéká tàbí WhatsApp)",
    maritalStatus: "Ipò Ìgbéyàwó",
    pleaseSpecify: "Jọ̀wọ́ ṣàlàyé",
    nationalId: "Nọ́mbà Ìdánimọ̀ Orílẹ̀-èdè (NIN)",
    enterNIN: "Fi NIN sílẹ̀",
    driverLicense: "Ìwé Àṣẹ Awakọ̀ (kò pọn dandan)",
    enterLicenseNumber: "Fi nọ́mbà ìwé àṣẹ sílẹ̀",
    
    // Marital Status Options
    single: "Àìgbéyàwó",
    married: "Ìgbéyàwó",
    divorced: "Ìkọ̀sílẹ̀",
    widowed: "Opó",
    other: "Mìíràn",
    
    // Labels - Residency
    lastAddress1: "Àdírẹ́sì Tó Kọjá 1",
    enterPreviousAddress: "Fi àdírẹ́sì tẹ́lẹ̀ rẹ sílẹ̀",
    lastAddress2: "Àdírẹ́sì Tó Kọjá 2",
    anotherPreviousAddress: "Fi àdírẹ́sì mìíràn sílẹ̀ (tí ó bá wà)",
    lastTenantAddress: "Àdírẹ́sì Ibùgbé Tẹ́lẹ̀",
    tenantAddressPlaceholder: "Àdírẹ́sì níbi tí o ti jẹ́ ayàgbé",
    durationAtLastLocation: "Àkókò tí o lò níbẹ̀",
    durationPlaceholder: "f.a., Ọdún 2",
    pastLandlordPhone: "Fóònù Onílé Tẹ́lẹ̀",
    reasonForLeaving: "Ìdí tí o fi lọ",
    whyDidYouLeave: "Kíni ìdí tí o fi kúrò níbẹ̀?",
    canLandlordBeContacted: "Ṣé a lè kàn sí onílé tẹ́lẹ̀ rẹ?",
    yes: "Bẹ́ẹ̀ni",
    no: "Bẹ́ẹ̀kọ́",
    
    // Labels - Employment
    occupation: "Iṣẹ́",
    selectOccupation: "Yan iṣẹ́",
    employed: "Oníṣẹ́",
    selfEmployed: "Alátọ̀wọ́dá",
    student: "Akẹ́kọ̀ọ́",
    retired: "Ti fẹ̀yìntì",
    unemployed: "Aláìníṣẹ́",
    durationOfEmployment: "Àkókò Iṣẹ́",
    monthlySalary: "Owó Oṣù (₦)",
    enterMonthlySalary: "Fi owó oṣù sílẹ̀",
    estimatedMonthlyReturns: "Èrè Oṣù tí a rò (₦)",
    enterEstimatedReturns: "Fi èrè tí a rò sílẹ̀",
    additionalOccupants: "Àwọn Ẹlòmíràn tí yóò gbé pọ̀",
    livingAlone: "Kò sí - Màá gbé ní àdá",
    onePerson: "Ènìyàn 1 síi",
    twoPeople: "Ènìyàn 2 síi",
    threePeople: "Ènìyàn 3 síi",
    fourOrMore: "Ènìyàn 4 tàbí jù bẹ́ẹ̀ lọ",
    rentalDuration: "Báwo ni o ṣe fẹ́ pẹ́ tó?",
    selectDuration: "Yan àkókò",
    sixMonths: "Oṣù 6",
    oneYear: "Ọdún kan",
    twoYears: "Ọdún 2",
    threeOrMoreYears: "Ọdún 3 síi",
    undecided: "Kò tíì pinnu",
    
    // Labels - Guarantors
    guarantor1: "Onígbọ̀wọ́ Kìíní",
    guarantor2: "Onígbọ̀wọ́ Kejì",
    guarantorName: "Orúkọ Kíkún",
    enterGuarantorName: "Fi orúkọ onígbọ̀wọ́ sílẹ̀",
    guarantorPhone: "Nọ́mbà Fóònù",
    enterPhoneNumber: "Fi nọ́mbà fóònù sílẹ̀",
    guarantorAddress: "Àdírẹ́sì",
    enterGuarantorAddress: "Fi àdírẹ́sì onígbọ̀wọ́ sílẹ̀",
    canGuarantorBeContacted: "Ṣé a lè kàn sí onígbọ̀wọ́ yìí?",
    select: "Yan",
    
    // Buttons
    previous: "Tẹ́lẹ̀",
    next: "Tẹ̀síwájú",
    submitApplication: "Fi Fọọmu Ránṣẹ́",
    submitting: "Ń fi ránṣẹ́...",
    requestNewLink: "Béèrè fún Ìjápọ̀ Tuntun",
    goToLogin: "Lọ sí Ìwọlé",
    
    // Messages
    linkInvalidOrExpired: "Ìjápọ̀ Kò Tọ́ tàbí Ti Parí",
    contactAdmin: "Jọ̀wọ́ kàn sí aláṣẹ ní WilyRash Homes fún ìjápọ̀ tuntun.",
    applicationSubmitted: "A Ti Gba Fọọmu!",
    thankYouMessage: "O ṣeun fún fífi fọọmu rẹ ránṣẹ́. A óò ṣàyẹ̀wò rẹ̀ láìpẹ́ a sì máa kàn sí ẹ.",
    ifApproved: "Tí a bá fọwọ́ sí ohun tí o fi sílẹ̀, a óò pè ọ́ láti ṣẹ̀dá àkọsílẹ̀ rẹ.",
    completeAllFields: "Jọ̀wọ́ parí gbogbo àyè tí ó pọn dandan",
    linkValidMessage: "Ìjápọ̀ wà ní ìlò. Jọ̀wọ́ parí fọọmu rẹ kí àkókò tó parí.",
    applicationSubmittedSuccess: "A ti gba fọọmu rẹ!",
    failedToSubmit: "Kò ṣeé ṣe láti fi fọọmu ránṣẹ́",
    validatingLink: "Ń ṣàyẹ̀wò ìjápọ̀...",
    
    // Footer
    footer: "Ètò Ìṣàkóso Ayàgbé WilyRash Homes",
    
    // Required indicator
    required: "*",
    
    // Photo upload
    passportPhoto: "Fọ́tò Ìrìnnà / Àwòrán Ara Ẹni",
    uploadPhoto: "Fi Fọ́tò Sílẹ̀",
    changePhoto: "Yí Fọ́tò Padà",
    photoRequired: "Fọ́tò pọn dandan",
    photoInstructions: "Jọ̀wọ́ fi fọ́tò tó ṣe kedere sílẹ̀",
    clickToUpload: "Tẹ láti fi sílẹ̀",
    dragAndDrop: "tàbí fà sí ibí",
    supportedFormats: "PNG, JPG, JPEG tó kéré ju 5MB"
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
